import {ROYAL_BLUE} from '../../globalVariables/GlobalVariables';

type InfoCircleProps = {
    className?: string;
    size?: number;
    circleFill?: string;
};

const InfoCircle = ({className, size = 20, circleFill = ROYAL_BLUE}: InfoCircleProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        className={className}
        aria-hidden
    >
        <circle cx="10" cy="10" r="10" fill={circleFill} />
        <path
            d="M10 14V9M10 6h.01"
            stroke="white"
            strokeWidth="1.8"
            strokeLinecap="round"
        />
    </svg>
);

export default InfoCircle;
